// Libraries
import React from 'react'
import Link from '~/components/Link'
import _ from 'lodash'

import popup from '~/views/Popup/popup'
import avatar from '~/assets/images/avatar.png'
import {BackArrowIcon } from '~/assets/svg';

import { logout } from '~/redux/user/helpers'
import accessLevelCheck from '~/tools/accessLevelCheck'
import makeSticky from '~/tools/sticky'
import { logoutUser } from '~/tools/analytics/cleverTap'

import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import profileStore from "~/redux/profile/store";
// import modelStore from '~/redux/models/store'

import './style.scss'
import { localizeTitle} from '~/tools/localization'
import { getUserProfile } from '~/services/profileService';

class Masthead04 extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			mobileMenuOpen: false,
			primaryNav: _.get(window.settings, 'navigation.primary', []),
			rightNav: _.get(window.settings, 'navigation.right', []),
			userNav: _.get(window.settings, 'navigation.user', []),
			moreNav: _.get(window.settings, 'navigation.more', []),
			primaryCta: _.get(window.settings, 'navigation.settings.primaryCta', {}) ,
			showMobileMenu: window.innerWidth <= 768
		}
		this.handleSearch = this.handleSearch.bind(this)
	}

	get logoStyle(){
		return {
			width: '125px',
			padding: '30px',
			backgroundImage: `url("${_.get(window.settings, 'images.desktopLogo')}")`,
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center center'
		}
	}

	get activeStyle(){
		const style = _.get(window.settings, "brand.navigation['link--active'].style")
		const textStyle = _.includes(style, 'underline') ? { textDecoration: 'underline'} : 
						  _.includes(style, 'bold') ? { fontWeight: 'bold' } : 
						  _.includes(style, 'italic') ? { fontStyle: 'italic' } : {}
		return {
			...textStyle,
			backgroundColor: _.get(window.settings, "brand.navigation['link--active'].backgroundColor"),
			color: _.get(window.settings, "brand.navigation['link--active'].textColor")
		}
	}

	get dropDownStyle(){
		return {
			// backgroundColor: _.get(window.settings, "brand.navigation.dropdown.backgroundColor"),
			color: _.get(window.settings, "brand.navigation.dropdown.textColor"),
		}
	}

	getMouseOverStyle(el) {
		el.currentTarget.style.color =  _.get(window.settings, "brand.navigation['link--active'].textColor");
	}

	getMouseOutStyle(el, active) {
		if(!active || this.state.mobileMenuOpen) {
			el.currentTarget.style.color =  _.get(window.settings, "brand.navigation.link.textColor");
		}
	}

	get linkStyle(){
		return {
			backgroundColor: _.get(window.settings, "brand.navigation.link.backgroundColor"),
			color: _.get(window.settings, "brand.navigation.link.textColor"),
		}
	}

	componentDidMount(){
		if (this.masthead) makeSticky(this.masthead)
		window.addEventListener('resize', () => { this.setState({ showMobileMenu: window.innerWidth <= 768 }) }, false)
		this.modifyMoreNav();

		//show onboarding if not logged in
		if(!this.state.user){
			popup.fitnessOnboardingScreen({
				showCloseButton: false
			});
		} else {
			if(!this.state.profile.data && this.state.user.isSubscribed){
				popup.fitnessSetupProfile({
					showCloseButton: false
				});
			}
		}
	}

	modifyMoreNav = () => {
		if(!_.isEmpty(this.state.moreNav)) {
			this.setState({
				moreNav: [{items: this.state.moreNav, url: '/subnav', title: 'More'}]
			})
		}
	}

	handleSearch(){
		if (this.props.filtersSearch) {
			return () => {
				this.setState(({ searchFiltersOpen }) => ({
					searchFiltersOpen: !searchFiltersOpen
				}));
			};
		}
		return _ => popup.searchList()
	}

	toggleMobileMenu(){
		this.setState({
			mobileMenuOpen: !this.state.mobileMenuOpen
		})
	}

	pushButtonEvent(source) {
		if (!window.dataLayer)
			return

		window.dataLayer.push({
			'event': 'subscribe_cta_click',
			'source': source
		})
	}

	onLogoutClick(evt) {
		evt.preventDefault()
		logout().then(_ => {
			logoutUser()
		})
	}

	handleLogin() {
		if(this.state.user){
			this.showPlans();
		}
		else{
			popup.fitnessSignInCreate({
				showCloseButton: false
			});
		}
	}

	showPlans() {
		popup.fitnessChooseAPlan({
			showCloseButton: false
		});
	}

	shouldRenderSubscribeBtn() {
    if (window.settings.serviceType !== 'SVOD')
      return false
    if (!this.state.user)
      return true
    if (this.state.user && !this.state.user.isSubscribed)
      return true

    return false
  }

  subscribeBtn() {
		const { primaryCta } = this.state
    if (primaryCta.placement !== "Masthead") 
      return

    return (
      <a onClick={this.handleLogin.bind(this)} className="cta subscribe-button">
        { primaryCta.ctaText }
      </a>
    )
	}
	
	renderRightNav(checkUserAccessLevel) {
		const avtr =_.get(this.state.profile, 'data.profile.avatarUrl', avatar);

		return (<div style={{'display':'flex'}}>
			<div className={`navigation-right`}>
			{
				this.state.rightNav.filter(checkUserAccessLevel).map((l, i) => this.renderMenuItem(l, i))
			}
			</div>
			{this.state.user &&
				
					<div className="user-greeting-container">
						<div className="greeting">
							<a className="user-image-container" style={{backgroundImage: `url(${avtr})`}}/>
							{!this.state.showMobileMenu && 
								(<div>
									<span className="hello">Hello, <strong>{ this.state.userName || this.state.user.email.split('@')[0]} </strong></span>
									{ this.state.mobileMenuOpen && (<div className="mobile-icon"><i className="ion ion-ios-arrow-forward"></i></div>)}
								</div>)
							}
						</div>
						<div className="dropdown">
							{ _.map(this.state.userNav.filter(checkUserAccessLevel), (v, k) => {
								return (
									<a className='navigation-link' href={ v.url } key={ k } >{ localizeTitle(v) }</a>
								)
							}) }
							<a className='navigation-link' href="#logout" onClick={ e => this.onLogoutClick(e) }>Log Out</a>
        		</div>
					</div>											
				
			}
			</div>
		)
	}

	redirectMenuItem(e, menuItem) {
		if(_.isEmpty(menuItem.items)) {
			if(menuItem.title.toLowerCase() == 'sign out') {
				this.onLogoutClick(e);
			} else if(menuItem.title.toLowerCase() == 'send us feedback') {
				e.currentTarget.href = 'mailto:info@neoufitness.com';
			} else {
				e.currentTarget.href = menuItem.url;
			}
		} else {
			if(menuItem.title.toLowerCase() == 'more' && this.state.showMobileMenu) {
				e.currentTarget.nextElementSibling.style.display = 'block';
			}
		}
	}

	renderSubNavWebSingleItem(obj,index) {
			return (
				<div className='navigation-link' key={index}>
					<a href={ obj.url }
						 style={this.dropDownStyle} 
						 onMouseOver={el  => this.getMouseOverStyle(el)}
						 onMouseOut={el  => this.getMouseOutStyle(el)}
						 target={obj.newTab ? "_blank" : "_self"} 
						 className="dropdown-sub-link"
						 onClick={(e) => this.redirectMenuItem(e, obj)}>
						{ obj.icon && 
							<img className="dropdown-icon" src={obj.icon} alt={obj.title}/>
						}
					<span>{ localizeTitle(obj) }</span>
					</a>
				</div>
			)
	}

	renderSubNavWebView(items, isMoreNav, checkUserAccessLevel) {
		return (
			<div className={`nav-dropdown-list-container`}>
			{
				items.map((object, i) => (
					(isMoreNav) ? (
						object.title.toLowerCase() == 'your account' && object.items && object.items.filter(checkUserAccessLevel).map((obj, j) => (
							(obj.title.toLowerCase() !== 'sign in') && this.renderSubNavWebSingleItem(obj, j)
						))
					)	: ((this.renderSubNavWebSingleItem(object, i))
					))
				)
			}
			</div>
			)
	}

	renderSubNavMobileView(items, isMoreNav, localizedTitle, checkUserAccessLevel){
		return (
		<div className={`nav-sub-container`}>
			<div className={`navigation-container ${this.state.mobileMenuOpen ? 'open' : ''}`}>
				<div className="nav-sub-title">
					<div onClick ={(e) => e.currentTarget.closest('.nav-sub-container').style.display = 'none'} > <BackArrowIcon/> </div>
					<div>{localizedTitle.toUpperCase()}</div>
				</div>
				{ items.map((object) => (
					<div>
						<div className="more-heading">
							<div>{ localizeTitle(object) }</div>
						</div>
						{object.items && (isMoreNav ? (
							<div className={`navigation-primary`}>
								{
									object.items.filter(checkUserAccessLevel).map((l, i) => (l.title.toLowerCase() !== 'sign in') && this.renderMenuItem(l, i))
								}
							</div>
							) : (
								object.items.filter(checkUserAccessLevel).map((l, i) => this.renderMenuItem(l, i)))
							)
						}
					</div>))
				}
			</div>
		</div>)
	}

	renderMenuItem(menuItem, key, userNav, isMoreNav){
		//This is a hack to render a modal for the neou client instead of having a login/view plans page
		if(menuItem.title === 'Sign In'){
			return (
				<span key={menuItem.dragDropId} className={`navigation-link-container`} onClick={ this.handleLogin.bind(this) } >
						<a className='navigation-link'
						style={userNav ? this.dropDownStyle : this.linkStyle} >
							<span>
								{localizeTitle(menuItem)}
							</span>	
						</a>
				</span>
			)
		}
		if(menuItem.title === 'View Plans'){
			return (
				<span key={menuItem.dragDropId} className={`navigation-link-container`} onClick={ this.handleLogin.bind(this) } >
						<a className='navigation-link'
						style={userNav ? this.dropDownStyle : this.linkStyle} 
						onMouseOver={el  => this.getMouseOverStyle(el)}
						onMouseOut={el  => this.getMouseOutStyle(el)}>
							<span>
								{localizeTitle(menuItem)}
							</span>	
						</a>
				</span>
			)
		}
		if(menuItem.title === 'Search') {
			return (
				<div>
					{ this.shouldRenderSubscribeBtn() && this.subscribeBtn() }
					<span key={menuItem.dragDropId} className="search-icon" onClick={ this.handleSearch() } >
						{ !this.props.filtersSearch && <i className="ion-ios-search-strong" /> }
					</span>
				</div>
			)
		}
		
		if(menuItem){
			const path = window.location.pathname;
			const isDropdownItem = !this.state.showMobileMenu && !_.isEmpty(menuItem.items);
			let checkUserAccessLevel = accessLevelCheck(this.state.user)
			
			const active = (path === menuItem.url || ((path !== "") && path.indexOf(menuItem.title.toLowerCase()) !== -1))
			const localizedTitle = localizeTitle(menuItem)
				
			return (
				<span key={menuItem.dragDropId} className={`navigation-link-container ${isDropdownItem ? 'navigation-dropdown-container' : ''}`}>
					<a
						className={`${isDropdownItem ? 'navigation-dropdown-link' : 'navigation-link'} ${active ? 'active' : ''}`}
						onMouseOver={el  => this.getMouseOverStyle(el)}
						onMouseOut={el  => this.getMouseOutStyle(el, active)}
						onClick={(e) => this.redirectMenuItem(e, menuItem)}
						style={userNav ? this.dropDownStyle : (active ? this.activeStyle : this.linkStyle)} 
					>
						<span>
							{localizedTitle}
						</span>	
						{ (active && !isDropdownItem) && <div style={{backgroundColor: _.get(window.settings, "brand.navigation['link--active'].textColor")}} className='active-navigation-bottomline'></div> }
						{ menuItem.title!== 'Sign In' && this.state.mobileMenuOpen && <span className="mobile-icon"><i className="ion-ios-arrow-forward"></i></span>}
					</a>
					{!_.isEmpty(menuItem.items) && (
						this.state.showMobileMenu ? this.renderSubNavMobileView(menuItem.items, isMoreNav, localizedTitle, checkUserAccessLevel) :
						this.renderSubNavWebView(menuItem.items, isMoreNav, checkUserAccessLevel)
					)}
				</span>
			)
		}

		return null
	}

	render() {
		const checkUserAccessLevel = accessLevelCheck(this.state.user)
		const linkAlignment = _.get(this.props.layout, 'settings.linkAlignment')
		if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
			return (
				<nav className={`masthead04`} ref={div => { this.masthead = div }}>
					<div className="masthead04-container">
						<header>
							<div className={`mobile-navigation-icon`} onClick={evt => this.toggleMobileMenu(evt)}>
								<i className={`${this.state.mobileMenuOpen ? 'ion-close' : 'ion-navicon'}`}></i>
							</div>
							<div className="logo-container">
								<Link href="/home" className="logo" >
									<div style={this.logoStyle}></div>
								</Link>
							</div>
							{this.state.showMobileMenu &&
								this.renderRightNav(checkUserAccessLevel)
							}
							{this.state.showMobileMenu ? 
								(<div className={`navigation-container ${this.state.mobileMenuOpen ? 'open' : ''}`}>
									<div className={`navigation-primary ${linkAlignment}`}>
									{
										this.state.primaryNav.filter(checkUserAccessLevel).map((l, i) => this.renderMenuItem(l, i))
									}
									{
										this.state.moreNav.map((l, i) => this.renderMenuItem(l, i, null, true))
									}
									</div>
								</div>) : 
								(<div className={`navigation-container ${this.state.mobileMenuOpen ? 'open' : ''}`}>
									<div className={`navigation-primary ${linkAlignment}`}>
									{
										this.state.primaryNav.filter(checkUserAccessLevel).map((l, i) => this.renderMenuItem(l, i))
									}
									{
										this.state.moreNav.map((l, i) => this.renderMenuItem(l, i, null, true))
									}
									</div>
									{this.renderRightNav(checkUserAccessLevel)}
								</div>)
							}
							
						</header>
					</div>
				</nav>
			)
		} else {
			return (<nav></nav>)
		}
	}
}

connect(Masthead04, (state) => ({ user: state.user }), userStore);
connect(Masthead04, state => ({ profile: state.profile}), profileStore);
// connect(Masthead04, (state) => ({ models: state }), modelStore)

export default Masthead04;
